import { ViewStream } from 'spyne';
import {  CodePlaygroundNavTraits} from 'traits/code-playground-nav-traits';
import Tmpl from './template/code-playground-nav-arrow-btns.tmpl.html';

export class CodePlaygroundNavArrowBtns extends ViewStream {
  constructor(props = {}) {
    props.class = 'example-nav-buttons';
    props.template = Tmpl;
    props.examplesArr = props.data.states[0]
    props.channels = ["CHANNEL_CODE_CONTAINER", "CHANNEL_UI"];
    props.traits = [CodePlaygroundNavTraits]
    super(props);
  }

  addActionListeners() {
    return [
      ["CHANNEL_CODE_CONTAINER_UPDATE_EVENT", "codePlaygroundNav$OnExampleUpdated"],
          ["CHANNEL_UI_CLICK_EVENT", "codePlaygroundNav$UpdateExample", ".examples-nav-button"]

    ];
  }

  onNavBtnClicked(e){

   //console.log("NAV BTN CLICKED ",e);
  }

  onExampleCodeUpdated(e){
   //console.log('example code updated ',e.payload, this.props.data);

  }

  broadcastEvents() {
    return [
        ['button.examples-nav-button', 'click']
    ];
  }

  onRendered() {
    //console.log("NAV ARROW BTNS ",this.props);

  }
}
